import React, { useEffect, useState, useRef } from 'react';
import {Modal, ModalBody, Button} from 'react-bootstrap';
import JsPdf from "jspdf";
import SignatureCanvas from 'react-signature-canvas';
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';
import Connection from '../../../Calls'
import contract_page1 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0001.jpg'
import contract_page2 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0002.jpg'
import contract_page3 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0003.jpg'
import contract_page4 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0004.jpg'
import contract_page5 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0005.jpg'
import contract_page6 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0006.jpg'
import contract_page7 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0007.jpg'
import contract_page8 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0008.jpg'
import contract_page9 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0009.jpg'
import './modalContract.css'
import Backend from '../../../Backend';

const ModalContract = ({show, onHide, setShowModal, getUrlCheckout}) => {
  const [pic, setpic] = useState('');
  const ref = useRef(null);
  const [contractB64, setcontractB64] = useState('');
  const [document, setdoc] = useState('');
  const [Loading, setLoading] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

const isMobile = width <= 768;

  const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  useEffect(() => {
    generatePdf()
}, [])

useEffect(() => {
  if (pic) {
    generatePdf(true)
  }
}, [pic,contractB64 ])

  const loadImage = (url) => {
    return new Promise((resolve) => {
      let img = new Image();
      img.onload = () => resolve(img);
      img.src = url;
    })
  }
  const isEmpty = (obj) => {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object
}

  const generatePdf = (sending) =>{
/* ------------------------------- Propiedades ------------------------------ */
        var today = new Date();
        // var doc = new JsPdf('portrait', 'mm', 'letter',true);
        var doc = new JsPdf({ orientation: "portrait", unit: "mm", format: 'letter',compress:true });
        doc.setFontSize(9.5);
        // doc.setTextColor(255,0,0);


/* ---------------------------- Justificar texto ---------------------------- */
        var lMargin=30; //left margin in mm
        var rMargin=30; //right margin in mm
        var pdfInMM=215.9;  // width of A4 in mm
        var pageCenter=pdfInMM/2;

/* ----------------------------- Pagina 1 ----------------------------- */
        loadImage(contract_page1).then((page) => {

            doc.addImage(page, 'JPG', 0, 0, 216,279 );

            let line2 = `CONTRATO DE PRESTACIÓN DE SERVICIOS QUE CELEBRAN POR UNA PARTE 'WIREBIT, S.A.P.I DE C.V.' (EN ADELANTE REFERIDA COMO “WIREBIT”), REPRESENTADA EN ESTE ACTO POR SU REPRESENTANTE LEGAL, Y POR LA OTRA PARTE (EN ADELANTE REFERIDA COMO “EL CLIENTE”); A TODOS LOS ANTERIORES DE MANERA CONJUNTA SE LES DENOMINARÁ “LAS PARTES”, DE CONFORMIDAD CON LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:`

            var lines =doc.splitTextToSize(line2, (pdfInMM-lMargin-rMargin));
            doc.text(lines,30,28.5,{ align: "justify", maxWidth: pdfInMM-lMargin-rMargin })
            //
            doc.setFontSize(9);
            // doc.text(data.ID_RFC ,155,193.5,'left') //numero id rfc
            // doc.text(data.ID_RFC ,170,189.8,'left') //numero id rfc
            // doc.text(data.Direccion,43,207,'left') //numero id rfc

        /* ----------------------------- Pagina 2 ----------------------------- */
            doc.addPage();
            loadImage(contract_page2).then((page) => {
                doc.addImage(page, 'JPG', 0, 0, 216,279 );
                // doc.text(data.Direccion,43,64.5,'left') //numero id rfc
                // doc.text(data.ID_RFC ,137.2,69.9,'left') //numero id rfc

            /* ----------------------------- Pagina 3 ----------------------------- */
                doc.addPage();
                loadImage(contract_page3).then((page) => {
                    doc.addImage(page, 'JPG', 0, 0, 216,279 );
                /* ----------------------------- Pagina 4 ----------------------------- */
                    doc.addPage();
                    loadImage(contract_page4).then((page) => {
                        doc.addImage(page, 'JPG', 0, 0, 216,279 );
                    /* ----------------------------- Pagina 5 ----------------------------- */
                        doc.addPage();
                        loadImage(contract_page5).then((page) => {
                            doc.addImage(page, 'JPG', 0, 0, 216,279 );
                        /* ----------------------------- Pagina 6 ----------------------------- */
                            doc.addPage();
                            loadImage(contract_page6).then((page) => {
                                doc.addImage(page, 'JPG', 0, 0, 216,279 );
                            /* ----------------------------- Pagina 7 ----------------------------- */
                                doc.addPage();
                                loadImage(contract_page7).then((page) => {
                                    doc.addImage(page, 'JPG', 0, 0, 216,279 );
                                    // doc.text(`los días ${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`,110,132.7,'left') //3 inicio // 65 fin //31 mitad primer intento
                                    doc.text(`los días ${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`,30,142.7,'left') //3 inicio // 65 fin //31 mitad primer intento
                                    // doc.text(data.Nombre, pageCenter + 45, 185, 'center'); // Nombre completo
                                    if(pic){
                                        // doc.addImage(pic, 'PNG',  37, 198, 58, 10); // CHAPA FIRMA
                                        doc.addImage(pic, 'PNG',  121, 165, 58, 10); // CLIENTE FIRMA
                                    }
                                /* ----------------------------- Pagina 8 ----------------------------- */
                                    doc.addPage();
                                    loadImage(contract_page8).then((page) => {
                                        doc.addImage(page, 'JPG', 0, 0, 216,279 );
                                        let line2 = `QUE FORMA PARTE DEL CONTRATO DE PRESTACIÓN DE SERVICIOS CELEBRADO POR UNA PARTE WIREBIT S.A.P.I DE C.V., A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ “WIREBIT” Y, POR OTRA PARTE, /***/ A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ EL “CLIENTE”, EN CONJUNTO SE LES DENOMINARÁ LAS PARTES.`
                                        var lines =doc.splitTextToSize(line2, (pdfInMM-lMargin-rMargin));
                                        // doc.text(lines,30,48.5,'left')
                                        doc.text(lines,30,48.5,{ align: "justify", maxWidth: pdfInMM-lMargin-rMargin })

                                        doc.text(`${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`, 100,163.3,'left')
                                        // doc.text(data.Nombre, pageCenter + 37.5, 208, 'center'); // Nombre completo
                                        if(pic){
                                            doc.addImage(pic, 'PNG',  122, 194, 58, 10); // CLIENTE FIRMA
                                        }
                                    /* ----------------------------- Pagina 9 ----------------------------- */
                                        doc.addPage();
                                        loadImage(contract_page9).then((page) => {
                                            doc.addImage(page, 'JPG', 0, 0, 216,279 );

                                            let line2 = `QUE FORMA PARTE DEL CONTRATO DE PRESTACIÓN DE SERVICIOS CELEBRADO POR UNA PARTE WIREBIT S.A.P.I DE C.V., A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ “WIREBIT” Y, POR OTRA PARTE, /***/ A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ EL “CLIENTE”, EN CONJUNTO SE LES DENOMINARÁ LAS PARTES.`
                                            var lines =doc.splitTextToSize(line2, (pdfInMM-lMargin-rMargin));
                                            // doc.text(lines,30,45,'left')
                                            doc.text(lines,28,50,{ align: "justify", maxWidth: pdfInMM-lMargin-rMargin })
                                            doc.text(`${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`,100,171.9,'left')
                                            // doc.text(data.Nombre, pageCenter + 44.5, 222, 'center'); // Nombre completo
                                            if(pic){
                                                doc.addImage(pic, 'PNG',  124, 205, 58, 10); // CLIENTE FIRMA
                                            }

                                            setcontractB64(doc.output('dataurlstring').substring(51,doc.output('dataurlstring').length) )

                                            if(document === ''){
                                                setdoc(doc.output('bloburl'))
                                            }
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });

    
}

  const firmaCompletada = () => {
    var sefg = ref.current.getCanvas().toDataURL('image/png');
    setpic(sefg)
  }

  const sendContract = () => {
    setLoading(true); 
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
    Backend.sendContractCryptoBuy(localStorage.getItem('email'), localStorage.getItem('token'),response.payload.r01, contractB64, response => {
      if (response.status.code === '0'){
        onHide(false)
        store.addNotification({
          title: "Success",
          message: "Order exchange",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true
          }
        })
        getUrlCheckout();
      }
    })
  })
  }

  return(
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{borderBottom: 'none', padding: '5px 15px'}} closeButton />
      <ModalBody>
        <center>
          <h1 style={{color: '#000', fontSize: 20, fontWeight: 500}}>Acepta los términos y condiciones de compra</h1>
        </center>
        <center>
        <div style={{width: '70%'}}>
          <span style={{color: '#909090', fontSize: 16, fontWeight: 400}}>Antes de proceder al pago revisa y firma nuestros Términos y Condiciones de compra con tarjeta.</span>
        </div>
        </center>
        <div style={{padding: "10px 30px"}}>
          <center>
            {isMobile ?
              <a href={document} target="_blank" rel="noopener noreferrer">
                Ver Contrato
              </a>
              :
              <iframe src={document} className='custom-frame' width={"100%"} height={360*1} type="application/pdf"/>
            }
          </center>
            <div style={{border: '1px solid #D9D9D9', padding: 10}}>
              <div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                  <div>
                    <span>Firma aqui</span>
                  </div>
                  <div style={{position: 'absolute', right: 55}}>
                    <span style={{cursor: 'pointer', color: '#1F45FF'}} onClick={()=>{ref.current.clear(); setpic('')}}>Limpiar</span>
                  </div>
                </div>
              </div>
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <SignatureCanvas
                    penColor='blue'
                    canvasProps={{ width: 300, height: 70, style:{borderBottom: '1px solid #1F45FF'}  }}
                    onEnd={() => { firmaCompletada() }}
                    ref={ref}
                    // backgroundColor='rgba(255,0,0,8)'
                />
              </div>
            </div>
          <center>
          </center>
        </div>

        <center>
          <Button
            onClick={() => sendContract()}
            disabled={(pic === '' || Loading)}
            className="send-signature-btn" variant="primary"
          >
            {
              (Loading) ? 
                <Bounce size={20} color={"#FFFFFF"} animating={true} />
                : "Firma"
            }
          </Button>
        </center>
      </ModalBody>
    </Modal>
  )

}
export default ModalContract